import React, { useEffect, useState } from "react";
import { NavHashLink as NavLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { useContext } from "react";
import NavLinkContext from "../../context/NavLinkContext";

// components
import MegaMenu from "./MegaMenu";

// css
import "./Navbar.css";

// assets
import navLogo from "../../assets/images/StratCap-DIR-Logo-Reversed.png";
// import navLogo from "../../assets/images/StratCap_Digital_Infrastructure_REIT.png";
// import navLogoWhite from "../../assets/images/LOGO-WHITE.png";
// import { ReactComponent as HmcLogo } from "../../assets/images/HMC-Capital-logo.svg";
// import hmcLogo from "../../assets/images/HMC-Capital-logo.svg"

const Navbar = () => {
  const { navLinkColor, setNavLinkColor } = useContext(NavLinkContext);
  // const [transform, setTransform] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth,
    dynamicHeight: window.innerHeight,
  });
  // const [linkColor, setLinkColor] = useState('home')

  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth,
      dynamicHeight: window.innerHeight,
    });
  };

  // handle scroll function
  // const handleScroll = () => {
  //   if (window.scrollY > 250) {
  //     setTransform(true);
  //   } else {
  //     setTransform(false);
  //   }
  // };

  // Function for pressing the logo and it taking you home
  const handleHomePress = () => {
    window.scrollTo(0, 0);
  };

  // Scrolling to each section with an offset to account for the navbar
  const scrollWithOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.scrollY;
    const yOffset = -75;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
  };

  // renders the class of the dropdown menu based on scroll and if the dropdown is showing.
  function dropDownRender() {
    if (showDropDown === true) {
      return "nav-dropdown-show-white";
    } else {
      return "nav-dropdown-hide";
    }
  }

  // useEffect(() => {
  //   // initiate the event handler
  //   window.addEventListener("scroll", handleScroll, true);

  //   // this will clean up the event every time the component is re-rendered
  //   return function cleanup() {
  //     window.removeEventListener("scroll", handleScroll, true);
  //   };
  // }, []);

  useEffect(() => {
    window.addEventListener("resize", setDimension);

    return () => {
      window.removeEventListener("resize", setDimension);
    };
  }, [screenSize]);

  return (
    <>
      {screenSize.dynamicWidth < 1080 ? (
        <MegaMenu />
      ) : (
        <section className="sticky top-0 h-[83px] bg-hmcNavBg z-10" id="navbar">
          <div className="px-20">
            <div className="main-margin h-[83px] flex justify-between content-end">
              <div className="flex items-center">
                <Link
                  to="/home"
                  className="nav-icon"
                  onClick={() => {
                    handleHomePress();
                    setShowDropDown(false);
                    setNavLinkColor("home")
                  }}
                >
                  {/* <HmcLogo className="w-full mt-[-28px]" /> */}
                  <img src={navLogo} alt="nav logo" />
                </Link>
              </div>
              {/* dropdown nav for mobile */}
              <div className={dropDownRender()}>
                <ul className="mobile-ul">
                  {/* <li>
                  <NavLink
                    smooth
                    to="/digitalinfrastructure"
                    activeClassName="selected"
                    className=""
                    onClick={() => {
                      setShowDropDown(false);
                    }}
                  >
                    digital infrastructure
                  </NavLink>
                </li> */}
                  <li>
                    <NavLink
                      smooth
                      to="/home"
                      activeClassName="selected"
                      className=""
                      scroll={(el) => scrollWithOffset(el)}
                      onClick={() => {
                        setShowDropDown(false);
                      }}
                    >
                      home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      smooth
                      to="/investments"
                      activeClassName="selected"
                      className=""
                      scroll={(el) => scrollWithOffset(el)}
                      onClick={() => {
                        setShowDropDown(false);
                      }}
                    >
                      investments
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      smooth
                      to="/performance"
                      activeClassName="selected"
                      className=""
                      scroll={(el) => scrollWithOffset(el)}
                      onClick={() => {
                        setShowDropDown(false);
                      }}
                    >
                      performance
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      smooth
                      to="/team"
                      activeClassName="selected"
                      className=""
                      scroll={(el) => scrollWithOffset(el)}
                      onClick={() => {
                        setShowDropDown(false);
                      }}
                    >
                      team
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      smooth
                      to="/investorrelations"
                      activeClassName="selected"
                      className=""
                      scroll={(el) => scrollWithOffset(el)}
                      onClick={() => {
                        setShowDropDown(false);
                      }}
                    >
                      investor relations
                    </NavLink>
                  </li>
                </ul>
              </div>
              {/* nav dropdown end */}
              {/* mobile hamburger start */}
              <div
                className="navbar-mobile-hamburger"
                onClick={() => setShowDropDown(!showDropDown)}
              >
                {/* <span>M</span> */}
                <div className=""></div>
                <div className=""></div>
                <div className=""></div>
              </div>
              {/* mobile hamburger end */}
              <div className="navbar-links grid content-end py-4">
                <ul>
                  {/* <li>
                  <NavLink
                    smooth
                    to="/digitalinfrastructure"
                    activeClassName="selected"
                    className="text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                    scroll={(el) => scrollWithOffset(el)}
                  >
                    digital infrastructure
                  </NavLink>
                </li> */}
                  <li>
                    <NavLink
                      smooth
                      to="/home"
                      activeClassName="selected"
                      onClick={() => setNavLinkColor("home")}
                      // className="text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      className={`${
                        navLinkColor === "home"
                          ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                          : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      }`}
                      scroll={(el) => scrollWithOffset(el)}
                    >
                      home
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      smooth
                      to="/investments"
                      activeClassName="selected"
                      onClick={() => setNavLinkColor("investments")}
                      // className="text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      className={`${
                        navLinkColor === "investments"
                          ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                          : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      }`}
                      scroll={(el) => scrollWithOffset(el)}
                    >
                      investments
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      smooth
                      to="/performance"
                      activeClassName="selected"
                      onClick={() => setNavLinkColor("performance")}
                      // className="text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      className={`${
                        navLinkColor === "performance"
                          ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                          : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      }`}
                      scroll={(el) => scrollWithOffset(el)}
                    >
                      performance
                    </NavLink>
                  </li>

                  <li>
                    <NavLink
                      smooth
                      to="/team"
                      activeClassName="selected"
                      onClick={() => setNavLinkColor("team")}
                      // className="text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      className={`${
                        navLinkColor === "team"
                          ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                          : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      }`}
                      scroll={(el) => scrollWithOffset(el)}
                    >
                      team
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      smooth
                      to="/investorrelations"
                      activeClassName="selected"
                      onClick={() => setNavLinkColor("investorrelations")}
                      // className="text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      className={`${
                        navLinkColor === "investorrelations"
                          ? "text-hmcBlue uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                          : "text-white uppercase text-[13px] tracking-widest hover:text-hmcBlue transition-all"
                      }`}
                      scroll={(el) => scrollWithOffset(el)}
                    >
                      investor relations
                    </NavLink>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default Navbar;
